import { render, staticRenderFns } from "./EditCharity.vue?vue&type=template&id=78524b9c&scoped=true&"
import script from "./EditCharity.vue?vue&type=script&lang=js&"
export * from "./EditCharity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78524b9c",
  null
  
)

export default component.exports